import { save, retrieve } from './storage'

const createLogStore = (initialLogs = []) => {
  if (!Array.isArray(initialLogs)) {
    throw new TypeError('Initial logs must be an array.')
  }

  let logs = initialLogs
  let unsavedUpdate = false
  let maxLogCapacity = 3000
  let storageFrequency = 5000
  let storageKey = 'logs'
  let shouldPersist = false
  let saveInterval

  return {
    set maxLogCapacity(newMaxLogCapacity) {
      maxLogCapacity = newMaxLogCapacity
    },

    set storageKey(newKey) {
      storageKey = newKey
    },

    set storageFrequency(newFrequency) {
      storageFrequency = newFrequency
    },

    set shouldPersist(newShouldPersist) {
      shouldPersist = newShouldPersist
    },

    get logs() {
      return [...logs]
    },

    add(log) {
      unsavedUpdate = true

      if (Array.isArray(log)) {
        logs = [...logs, ...log]
      } else {
        logs.push(log)
      }

      if (logs.length > maxLogCapacity) {
        logs.shift()
      }

      if (shouldPersist && !saveInterval) {
        saveInterval = setInterval(() => {
          if (unsavedUpdate) {
            save(storageKey, logs)
          }

          unsavedUpdate = false
        }, storageFrequency)
      }
    },

    loadStoredLogs() {
      retrieve(storageKey)
    },

    stopStoring() {
      clearInterval(saveInterval)
      unsavedUpdate = false
    },

    clear() {
      logs = []
      save(storageKey, logs)
      unsavedUpdate = false
    },
  }
}

export default createLogStore
